
import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { PickTicketDetailNewFlowItemDetailsModalStore } from 'application/pick-ticket-new-flow/stores';
import { PickTicketDetailNewFlowItemDetailsModalTemplate } from 'themes/application/pick-ticket-new-flow/components';

@setCurrentView((rootStore, componentProps) => new PickTicketDetailNewFlowItemDetailsModalStore(rootStore, componentProps), 'pickTicketDetailNewFlowItemDetailsModalStore')
@observer
class PickTicketDetailNewFlowItemDetailsModal extends React.Component {
    render() {
        return <PickTicketDetailNewFlowItemDetailsModalTemplate {...this.props} />
    }
}

export default PickTicketDetailNewFlowItemDetailsModal;
